import { InfoDetailsProps } from 'components/info-component/info-component';
import { TableColumnProps } from 'components/table/table-component/table-component';

export const tableStructureWithOrg: TableColumnProps[] = [
  {
    id: 'name',
    title: 'Team Name',
    withSort: true,
    withSearch: true,
    position: 'left',
    noFilters: true,
  },
  {
    id: 'team_risk_score',
    title: 'Risk Score',
    withSort: true,
    position: 'left',
  },
  {
    id: 'team_vulnerability_score',
    title: 'Vuln. Score',
    withSort: true,
    position: 'left',
    noFilters: true,
  },
  {
    id: 'scm_source',
    title: 'Source',
    withSort: true,
    position: 'left',
    noFilters: true,
  },
  {
    id: 'owner',
    title: 'Organization',
    withSort: true,
    withSearch: true,
    position: 'left',
    noFilters: true,
  },
  {
    id: 'num_total',
    title: 'Members',
    withSort: true,
    position: 'left',
    noFilters: true,
  },
  {
    id: 'num_inactive',
    title: 'Inactive members',
    withSort: true,
    position: 'left',
    noFilters: true,
  },
  {
    id: 'repos_count',
    title: 'Repositories',
    withSort: true,
    position: 'left',
    noFilters: true,
  },
  {
    id: 'last_activity',
    title: 'Last Event',
    withSort: true,
    position: 'left',
    isDate: true,
    noFilters: true,
  },
];

export const teamInfoStructure: InfoDetailsProps[] = [
  {
    id: 'name',
    title: 'Team',
  },
  {
    id: 'team_risk_score',
    title: 'Risk Score',
  },
  {
    id: 'average_vuln_per_repo',
    title: 'Avg Vuln. Per Repo',
  },
  {
    id: 'org',
    title: 'Organization',
  },
  {
    id: 'status',
    title: 'Status',
  },
  {
    id: 'total_repos',
    title: '# Repositories with access',
  },
  {
    id: 'identities',
    title: '# Identities',
  },
  {
    id: 'entity_graph',
    title: 'Graph',
  },
];
